import { getCurrentSystem, SYSTEM_TYPE } from '@umu/ukit-lang';

const priorityOrigin = SYSTEM_TYPE.JP;

// UMU public CDN
const publicCDNOriginMap: Record<keyof typeof SYSTEM_TYPE, string> = {
    CN: 'https://statics-cdn-cn.umucdn.cn',
    JP: 'https://dpfrzbu0cqnmm.cloudfront.net',
    EN: 'https://d1bvk99i2a79wx.cloudfront.net',
    EM: 'https://dmks9efzatfsk.cloudfront.net',
    TW: 'https://d1yemi1ss2f2oh.cloudfront.net',
    ATES: '',
};

// 客户 CDN
export const customerCDNOriginMap: Record<keyof typeof SYSTEM_TYPE, { auth: string; noAuth: string }> = {
    CN: {
        auth: '',
        noAuth: 'https://umu-cn.umucdn.cn',
    },
    JP: {
        auth: '',
        noAuth: 'https://d1dw9odj9f4xrp.cloudfront.net',
    },
    EN: {
        auth: 'https://statics.umu.com',
        noAuth: 'https://dz4z9fk4z9ace.cloudfront.net',
    },
    EM: {
        auth: '',
        noAuth: 'https://resource.umu.io',
    },
    TW: {
        auth: 'https://statics.umu.tw',
        noAuth: 'https://d1iwrer5wugjum.cloudfront.net',
    },
    ATES: {
        auth: '',
        noAuth: '',
    },
};

export const getPublicCDNOrigin = (system: keyof typeof SYSTEM_TYPE = getCurrentSystem()) => {
    return publicCDNOriginMap[system] || publicCDNOriginMap[priorityOrigin];
};

export const checkIsAuthCDNUrl = (cdnUrl: string | undefined): boolean => {
    if (!cdnUrl || typeof cdnUrl !== 'string') {
        return false;
    }
    const authCDNDomains = ['statics-test.umu.tw', 'statics.umu.tw', 'statics-test.umu.com', 'statics.umu.com'];
    return authCDNDomains.some((domain) => cdnUrl.includes(domain));
};

export const setImgCrossOrigin = (img: HTMLImageElement, cdnUrl: string) => {
    if (checkIsAuthCDNUrl(cdnUrl)) {
        img.crossOrigin = 'use-credentials';
    } else {
        img.crossOrigin = 'anonymous';
    }
};

// 将客户 cdn 地址 转换为无需鉴权的 cdn 地址
export const convertToNoAuthCDN = (cdnUrl: string) => {
    const system = getCurrentSystem();
    const cdnOrigin = customerCDNOriginMap[system];
    if (cdnOrigin && cdnOrigin.auth && cdnOrigin.noAuth) {
        return cdnUrl.replace(cdnOrigin.auth, cdnOrigin.noAuth);
    }
    return cdnUrl;
};
